<template>
	<v-list class="sidebar-list pa-0">
		<NoteItem
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.upload_id"
			:resourceItem="resourceItem"
		/>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NoteItem from '@/components/Profile/NoteItem.vue'

export default {
	name: 'NoteList',
	components: {
		NoteItem
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler'])
	},
	created() {
		//
	}
}
</script>

<style lang="scss">
.rotate-90-deg {
	transform: rotate(90deg);
}
.truncate-2-lines {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
}
.popular-post-by-category {
	color: #37474f;
	padding: 18px 10px 16px 20px;
	border-radius: 11px;
	margin-bottom: 16px;
	width: 100%;
	background: #e2f2e9;
	box-shadow: none !important;

	&__title {
		padding-bottom: 25px;
		p {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: bold;
			font-size: 14px;
			line-height: 17px;
			letter-spacing: 0.35px;
			color: #202232;
		}

		a {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 15px;
			text-align: center;
			letter-spacing: 0.35px;
			color: #000 !important;
			mix-blend-mode: normal;
			opacity: 0.4;
			text-decoration: none;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}
		}
	}

	&__thing-title {
		.thing-link {
			font: 500 16px/1.5 'Montserrat';
		}
	}

	&__user-name {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
		word-break: break-all;
	}
	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__user-location {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
	}

	&__link {
		font: 500 16px/1.5 'Montserrat';
		text-decoration: none;
		color: #37474f !important;

		&:hover {
			transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
			color: black !important;
			text-decoration: underline;
		}
	}
}
</style>
